<template>
  <div id="task" class="task-box">
    <el-collapse
      v-if="
        (collapseData.length > 0 || huotiImg.length > 0 || huotiVideo.length > 0 || !foldshow) && foldshow
      "
      v-model="activeNameCollapse"
      @change="collapseChange"
    >
      <div v-if="collapseData.length > 0">
        <el-collapse-item
          v-for="item in collapseData"
          :key="item.mType"
          :title="item.mTypeName"
          :name="item.mType"
        >
          <div v-if="item.dataLoaded">
            <div v-for="file in item.materialList" :key="file.fileType">
              <div v-if="file.srcListImage && file.srcListImage.length > 0">
                <el-image
                  class="image"
                  v-for="(img, index) in file.srcListImage"
                  :key="index"
                  :src="img"
                  :preview-src-list="file.srcListImage"
                >
                </el-image>
              </div>
              <div v-if="file.srcListPDF && file.srcListPDF.length > 0">
                <img
                  class="pdf"
                  v-for="(pdf, index) in file.srcListPDF"
                  :key="index"
                  src="@/assets/images/pdf.png"
                  @click="openPDF(pdf)"
                />
              </div>
              <div v-if="file.srcListVideo && file.srcListVideo.length > 0">
                <video
                  class="video"
                  v-for="(video, index) in file.srcListVideo"
                  :key="index"
                  :src="video"
                  controls
                ></video>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </div>
      <!-- 活体图片 -->
      <el-collapse-item
        v-if="huotiImg.length > 0"
        title="活体图片"
        name="huotiImg"
      >
        <el-image
          class="image"
          v-for="(img, index) in huotiImg"
          :key="index"
          :src="img"
          :preview-src-list="huotiImg"
        >
        </el-image>
      </el-collapse-item>
      <!-- 活体视频 -->
      <el-collapse-item
        v-if="huotiVideo.length > 0"
        title="活体视频"
        name="huotiVideo"
      >
        <video
          class="video"
          v-for="(video, index) in huotiVideo"
          :key="index"
          :src="video.src"
          controls
        ></video>
      </el-collapse-item>
    </el-collapse>

    <!-- el-icon-s-unfold -->
    <!-- <el-button v-if="foldshow" @click="foldshow=!foldshow" type="info" icon="el-icon-d-arrow-left"  circle></el-button>
    <el-button v-else @click="foldshow=!foldshow" type="info" icon="el-icon-d-arrow-right"  circle></el-button> -->
    <div @click="foldshow=!foldshow" class="foldcss" v-if="collapseData.length > 0" :title="foldshow ? '隐藏' : '展示'"><i :class="foldshow ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></i></div>
    <div class="task-content" :class="collapseData.length > 0 && foldshow ? 'w-calc' : ''">

      <el-tabs
        type="border-card"
        v-model="activeNameTab"
        @tab-click="handleClick"
      >
        <el-tab-pane name="first">
          <span slot="label"><i class="el-icon-date" />关键信息</span>
          <item-information v-if="activeNameTab == 'first'" />
        </el-tab-pane>
        <!-- <el-tab-pane name="second">
        <span slot="label"><i class="el-icon-date" />影像资料</span>
        <item-viewInformation v-if="activeNameTab == 'second'" />
      </el-tab-pane> -->
      </el-tabs>
      <div class="btn-wrapper">
        <el-button type="primary" @click="nextArticle('1')">上一条</el-button>
        <el-button type="primary" @click="nextArticle('2')">下一条</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  nextArticle,
  queryMaterialList,
  queryMaterialListByType,
  queryFaceList,
} from "@/api/task";
import { information, keyViewInformation } from "./components";
import { mapGetters } from "vuex";

export default {
  name: "task",
  data() {
    return {
      activeNameTab: "first",
      activeNameCollapse: [],
      userId: null,
      collapseData: [],
      collapseValOld: [],
      huotiImg: [],
      huotiVideo: [],
      foldshow: true,
      searchParams: {}
    };
  },
  components: {
    "item-information": information,
    "item-viewInformation": keyViewInformation,
  },
  computed: {
    ...mapGetters(["currentUser", "myTaskListStatus"]),
    id() {
      return this.$route.params.loanId;
    },
    taskId() {
      return this.$route.params.taskId;
    },
    status() {
      return this.$route.params.status;
    },
  },
  async created() {
    document.title = sessionStorage.getItem("borrowerName");
    const userId = sessionStorage.getItem("userId");
    this.searchParams = this.$route.query 
    console.log('route.query:',this.$route.query)
    if (userId) {
      this.userId = userId;
    }
    await queryMaterialList({ taskId: this.taskId, userId: this.userId }).then(
      (res) => {
        res.data.map((item) => {
          item.dataLoaded = false;
        });
        this.collapseData = res.data;
      }
    );
    await this.queryFaceListData();

  },
  methods: {

    openPDF(pdf) {
      window.open(pdf);
    },
    // 活体图片 活体视频
    async queryFaceListData() {
      await queryFaceList({ taskId: this.taskId }).then((res) => {
        if (res.data) {
          if (res.data.pictureBase64) {
            this.huotiImg.push(res.data.pictureBase64);
          }
          if (res.data.videoBase64) {
            const videoObj = { src: res.data.videoBase64 };
            this.huotiVideo.push(videoObj);
          }
        }
      });
    },
    async collapseChange(val) {
      const oldLength = this.collapseValOld.length;
      const length = val.length;
      if ((oldLength > 0 && oldLength < length) || oldLength <= 0) {
        const mType = val[length - 1];
        this.collapseData.forEach((item) => {
          if (item.mType === mType) {
            item.dataLoaded = false;
          }
        });
        await this.queryMaterialListByTypeFun(mType);
      }
      this.collapseValOld = val;
    },
    async queryMaterialListByTypeFun(mType) {
      if (mType && mType !== "huotiImg" && mType !== "huotiVideo") {
        await queryMaterialListByType({
          taskId: this.taskId,
          userId: this.userId,
          type: mType,
        }).then((res) => {
          if (res.data.length > 0) {
            res.data.forEach((item) => {
              item["srcListImage"] = [];
              item["srcListPDF"] = [];
              item["srcListVideo"] = [];
            });
            res.data.map((item) => {
              if (item.type === "Image") {
                item.srcListImage.push(item.ossUrl);
              } else if (item.type === "PDF") {
                item.srcListPDF.push(item.ossUrl);
              } else if (item.type === "Video") {
                item.srcListVideo.push(item.ossUrl);
              }
            });
          }
          this.collapseData.forEach((item) => {
            if (item.mType === mType) {
              item["materialList"] = res.data;
              item.dataLoaded = true;
            }
          });
        });
      }
    },
    handleClick(tab) {
      this.activeNameTab = tab.index == 0 ? "first" : "second";
    },
    async nextArticle(type) {
      this.searchParams.userId = this.currentUser.id
      this.searchParams.type = type
      this.searchParams.taskId = this.taskId
      this.searchParams.status = this.status
      const res = await nextArticle(this.searchParams);
      if (res.data && res.data.id) {
        sessionStorage.setItem("borrowerName", res.data.borrowerName);
        // this.$router.push({
        //   name: "taskDetail",
        //   params: {
        //     taskId: res.data.id,
        //     status: this.status,
        //     loadId: "1",
        //   },
        // });
        window.location.href = `/#/task/${res.data.id}/1/${this.status}?${ this.getSearchParamsQueryString() }`
        window.location.reload()
      } else {
        this.$message("已经没有数据了");
      }
    },

    getSearchParamsQueryString() {
      return Object.entries(this.searchParams)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    },
  },
};
</script>

<style lang="scss" scoped>
.button-area {
  margin-bottom: 12px;
}

.btn-wrapper {
  padding-top: 30px;
  text-align: center;
}

.task-box {
  display: flex;
  justify-content: space-between;
  // overflow: hidden;
  // scrollbar-width: none;
  // scrollbar-color: transparent transparent;

  // ::-webkit-scrollbar {
  //   display: none;
  // }

  ::v-deep .el-collapse {
    width: 200px;
    height: 100vh;
    overflow-y: auto;
  }

  ::v-deep .el-collapse-item__content {
    text-align: center;
  }

  ::v-deep .el-collapse-item__header {
    padding-left: 8px;
  }

  .image {
    width: 80%;
  }

  .pdf {
    width: 80%;
    cursor: pointer;
  }

  .video {
    width: 80%;
    cursor: pointer;
  }

  .w-calc {
    width: calc(100% - 215px);
  }

  .task-content {
    height: 100vh;
    overflow-y: auto;
  }
  .foldcss{
    height: 100vh;
    width: 15px;
    text-align: center;
    line-height: 100vh;
    background-color: rgba(48, 49, 51, 0.6);
    i {
      color: white;
    }
  }
}
</style>
